import type { SpinnerSize } from '@shared/ui/spinner';

import type { IconButtonShape, IconButtonSize, IconButtonVariant } from './icon-button.ui';

/** Figma `IconButton`(5:414). hover · pressed 는 누를 수 있을 때만 */
export const VARIANT_CLASS: Record<IconButtonVariant, string> = {
  primary:
    'bg-bg-primary text-on-primary enabled:hover:bg-bg-primary-hover enabled:active:bg-bg-primary-pressed disabled:bg-bg-disabled disabled:text-fg-disabled',
  outline:
    'border border-border-control bg-bg-surface text-fg-default enabled:hover:bg-bg-hover enabled:active:bg-bg-pressed disabled:border-border-default disabled:bg-bg-disabled disabled:text-fg-disabled',
  ghost:
    'text-fg-default enabled:hover:bg-bg-hover enabled:active:bg-bg-pressed disabled:text-fg-disabled',
};

/** 정사각형 상자: xs 24 · sm 32 · md 40 · lg 48 */
export const SIZE_CLASS: Record<IconButtonSize, string> = {
  xs: 'size-(--size-control-2xs)',
  sm: 'size-(--size-control-sm)',
  md: 'size-(--size-control-md)',
  lg: 'size-(--size-control-lg)',
};

/** 알림 점: xs 8 · 나머지 10, 오른쪽 위 */
export const DOT_CLASS: Record<IconButtonSize, string> = {
  xs: 'top-0 right-0 size-2',
  sm: 'top-1 right-1 size-2-5',
  md: 'top-1 right-1 size-2-5',
  lg: 'top-1 right-1 size-2-5',
};

/** loading 때 Spinner: lg 만 md(24) */
export const SPINNER_SIZE: Record<IconButtonSize, SpinnerSize> = {
  xs: 'sm',
  sm: 'sm',
  md: 'sm',
  lg: 'md',
};

/** 모양: square = 모서리 4, circle = 원(면 · hover · pressed 가 모두 원으로 칠해진다) */
export const SHAPE_CLASS: Record<IconButtonShape, string> = {
  square: 'rounded-sm',
  circle: 'rounded-full',
};

/**
 * shape=circle 에서 variant 마다 덧씌우는 글자(아이콘) 색. primary 원 = 흰 아이콘(`color.fg.inverse`) —
 * 기존 btn_graphsearch.svg(#00ADA0 원 + 흰 선)와 사용자 요청 "Primary 컬러에 흰색 stroke"(DD-21 3)를 따른다.
 * 흰 아이콘 ↔ 면 bg.primary(primary-400 #4cc2b5) 대비 2.17:1(기존 #00ada0 이면 2.81:1)로 비텍스트 3:1(DD-3)에
 * 못 미친다 — 사용자 결정(DD-20 5 · DD-21 3). 버튼 이름은 aria-label 이 맡는다.
 * square primary 는 그대로 on-primary(neutral-950).
 */
export const CIRCLE_VARIANT_CLASS: Partial<Record<IconButtonVariant, string>> = {
  primary: 'text-fg-inverse',
};
